(()=>{
 function init(root=document){
  const header=root.querySelector('.pb-home .site-header');
  if(!header||header.dataset.menuReady)return;
  header.dataset.menuReady='true';
  // The existing cart drawer owns the live cart state. Mirror its count without
  // replacing any commerce handlers or intercepting network requests.
  const badge=header.querySelector('[data-pb-cart-count]');
  const cartRoot=document.querySelector('#side-cart')?.closest('.shopify-section');
  if(badge&&cartRoot){
   const sync=()=>{const count=cartRoot.querySelector('[rv-text="cart.item_count"]')?.textContent.trim();if(/^[0-9]+$/.test(count))badge.textContent='('+count+')'};
   const observer=new MutationObserver(sync);
   observer.observe(cartRoot,{childList:true,characterData:true,subtree:true});
   sync();
   document.addEventListener('shopify:section:unload',e=>{
    if(e.target.contains(header))observer.disconnect();
   });
  }
  const toggle=header.querySelector('.menu-toggle'),nav=header.querySelector('nav');
  const close=()=>{toggle.setAttribute('aria-expanded','false');nav.classList.remove('is-open')};
  toggle.addEventListener('click',()=>{
   const open=toggle.getAttribute('aria-expanded')!=='true';
   toggle.setAttribute('aria-expanded',String(open));nav.classList.toggle('is-open',open);
  });
  nav.addEventListener('click',e=>{if(e.target.closest('a'))close()});
  document.addEventListener('keydown',e=>{
   if(e.key==='Escape'&&toggle.getAttribute('aria-expanded')==='true'){close();toggle.focus()}
  });
  document.addEventListener('click',e=>{if(!header.contains(e.target))close()});
  window.matchMedia('(min-width:1001px)').addEventListener('change',close);
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init());
 else init();
 document.addEventListener('shopify:section:load',e=>init(e.target));
})();
